import HTTP from '../../../../api/AxiosConfig';

export const getConsumedProductsReport = (request) =>
    HTTP.post('/report/consumed-products', request);
